export default __webpack_public_path__ + "static/media/employee_add.80a0a9ba.png";